import Button from '@gds/Button/Button';
import { PrefetchLink } from '@shared-components/PrefetchLink/PrefetchLink';

import styles from '../../Interlinking/Interlinking.module.css';

export interface Region {
  name: string;
  url: string;
}

export const InterlinkingRegionItem = ({ region }: { region: Region }) => (
  <li className={styles.list}>
    <PrefetchLink href={`/${region.url}`} key={region.name}>
      <Button variant="link" data-test-id={region.name} className={styles.links}>
        {region.name}
      </Button>
    </PrefetchLink>
  </li>
);
